import React from 'react';
import PatientProfileDataCompareTableRowItem from './PatientProfileDataCompareTableRowItem';
import { PatientCompareDataTableColumn } from '../../../Modules/Patient/Interfaces/Patient/PatientCompareDataTableColumn.interface';
import { PatientDataCompareKey } from '../../../Helpers/Patient/mapPatientDataToCompareTable.helper';
import { PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS } from '../../../Helpers/Patient/compareTableTranslations.helper';
import Text from '../../Base/Text/Text';
import styles from './PatientProfileDataCompareTableRow.module.scss';

interface Props {
	title: PatientDataCompareKey;
	columns: PatientCompareDataTableColumn[];
}

const PatientProfileDataCompareTableRow = ({ title, columns }: Props) => {
	return (
		<tr>
			<td className={styles.firstCell}>
				<Text
					tx={PATIENT_DATA_COMPARE_TABLE_TRANSLATIONS[title] || title}
					firstUpper
				/>
			</td>
			{columns.map((item, index) => (
				<PatientProfileDataCompareTableRowItem
					key={index}
					title={title}
					value={item.data[title]}
					compareTo={item.compareTo?.[title]}
					overwriteData={item.overwriteData}
				/>
			))}
		</tr>
	);
};

export default PatientProfileDataCompareTableRow;
